import apiFetch from '../apiFetch'
export default function (dniCif, organizedUnitId, token) {
  return apiFetch({ endPoint: `entity?dniCif=${dniCif}&organizedUnitId=${organizedUnitId}`, method: 'GET', body: null, token: token })
}
